"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listAssociatedComponents = void 0;
const products_1 = require("@/services/products");
const associatedComponents_1 = require("@/store/ducks/associatedComponents");
const products_2 = require("@/store/ducks/products");
function listAssociatedComponents(productId) {
    return async (dispatch) => {
        dispatch((0, associatedComponents_1.getAssociatedComponentsList)());
        (0, products_1.getAssociatedProductComponents)(productId)
            .then((product) => {
            const componentsRow = product.components.map((component) => {
                return {
                    id: component.id,
                    name: component.name,
                    unit: component.unit,
                    order: component.order,
                };
            });
            dispatch((0, products_2.setProductNameToBeAssociated)(product?.name));
            dispatch((0, products_2.setOriginalAssociatedProductName)(product?.name));
            dispatch((0, associatedComponents_1.getAssociatedComponentsListSuccess)(componentsRow));
        })
            .catch(() => {
            dispatch((0, associatedComponents_1.getAssociatedComponentsListError)());
        });
    };
}
exports.listAssociatedComponents = listAssociatedComponents;
